import type {ActionReducerMapBuilder} from '@reduxjs/toolkit';
import type {EventPromotionReducerState} from '@Components/mystuff-event-promotion-page/mystuff-event-promotion-page.types';
import {PromotionType} from '@Components/mystuff-event-promotion-page/mystuff-event-promotion-page.types';
import {deletePrintFlyerPoster, deleteSocialPostFromEvent, getEventPromotionInfo, markPromotionStepAsCompleted, markPromotionStepAsSkipped, refreshEventPromotionSteps} from '@Components/mystuff-event-promotion-page/mystuff-event-promotion-page-thunk';
import {LoadingStates} from '@Utils/loading.util';
import {getPromotionStepFromType, getStepsWithCompletedStepUnchecked} from "@Libraries/event-promotion.library";
import {PostState} from '@Components/social-media/post.vo';

export const mystuffEventPromotionPageExtraReducers = (builder: ActionReducerMapBuilder<EventPromotionReducerState>): void => {
  builder.addCase(getEventPromotionInfo.pending, (state) => {
    state.loadingState = LoadingStates.LOADING;
    state.hasFetchEventFailed = false;
  });

  builder.addCase(getEventPromotionInfo.rejected, (state, {meta}) => {
    if (meta.aborted) {
      return;
    }
    state.loadingState = LoadingStates.NOT_LOADED;
    state.hasFetchEventFailed = true;
  });

  builder.addCase(getEventPromotionInfo.fulfilled, (state, {payload}) => {
    state.event = payload.event;
    state.loadingState = LoadingStates.LOADED;
    state.stats = payload.stats;
    state.promotionSteps = payload.promotionSteps;
    state.socialPosts = payload.socialPosts;
    state.emailCampaigns = payload.emailCampaigns;
    state.printFlyers = payload.printFlyers;
    state.areEventPreviewsReady = payload.areEventPreviewsReady;
    state.isCalendarSetUp = payload.isCalendarSetUp;
    state.calendarPageUrl = payload.calendarPageUrl;
    state.canViewEarnings = payload.canViewEarnings;
    state.hasFetchEventFailed = false;
  });

  builder.addCase(refreshEventPromotionSteps.fulfilled, (state, {payload, meta}) => {
    if (meta.arg !== state.event.hashedID || !payload) {
      return;
    }
    state.promotionSteps = payload.map((refreshedStep) => {
      const shownStep = state.promotionSteps.find((step) => step.type === refreshedStep.type);
      return shownStep?.isCompleted ? {...refreshedStep, isCompleted: true, isSkipped: false} : refreshedStep;
    });
  });

    builder.addCase(markPromotionStepAsCompleted.pending, (state, {meta}): void  => {
        const step = getPromotionStepFromType(state.promotionSteps, meta.arg.promotionType);

        if (step) {
            step.isCompleted = true;
            step.isSkipped = false;
        }
    });

    builder.addCase(markPromotionStepAsSkipped.pending, (state, {meta}): void  => {
        const step = getPromotionStepFromType(state.promotionSteps, meta.arg.promotionType);

        if (step) {
            step.isCompleted = false;
            step.isSkipped = true;
        }
    });

    builder.addCase(deletePrintFlyerPoster.pending, (state, {meta}): void  => {
        state.printFlyers = state.printFlyers.filter(flyer => {
            return flyer.posterHashedID !== meta.arg.posterHashedId;
        });
    });

    builder.addCase(deleteSocialPostFromEvent.pending, (state, {meta}): void => {
        state.socialPosts = state.socialPosts.filter(post => {
            return post.id !== meta.arg.socialPostId;
        });

        if (!state.socialPosts.some((post) => post.state !== PostState.DRAFT)) {
            state.promotionSteps = getStepsWithCompletedStepUnchecked(state.promotionSteps, PromotionType.SOCIAL_POSTS);
        }
    });
};